import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "../components/ProtectedRoute";
import { Home } from "./Home";
import { ClientsList } from "./clients/ClientsList";
import { Email } from "./email/Email";
import { Invoices } from "./Invoices";
import { Managers } from "./managers/ManagersList";
import ClientView from "./clients/ClientView";
import { ManagerView } from "./managers/ManagerView";
import { Statistics } from "./Statistics";
import { useAuth } from "../hooks/AuthProvider";
import EmailResultView from "./email/EmailResultView";
import { EmailStatistics } from "./EmaillStatistics";
import { AccessRules } from "./AccessRules";

type UserRole = 'ADMIN' | 'USER';

interface RouteConfig {
  path: string;
  element: React.ReactNode;
  requiredRole?: UserRole;
}

const getRoutes = (isAdmin: boolean) => {
  const publicRoutes = [
    { path: "/", element: <Home /> },
    { path: "/clients", element: <ClientsList /> },
    { path: "/client/:clientId", element: <ClientView /> },
    { path: "/client", element: <ClientView /> },
    { path: "/emails/:resultId", element: <EmailResultView /> },
    { path: "/emails", element: <Email /> },
    { path: "/email-statistics", element: <EmailStatistics /> },
    { path: "/invoices", element: <Invoices /> },
    { path: "/managers-view", element: <ManagerView /> },
  ] as RouteConfig[];

  const adminRoutes = isAdmin ? [
    { path: "/managers", element: <Managers />, requiredRole: "ADMIN" },
    { path: "/statistics", element: <Statistics />, requiredRole: "ADMIN" },
    { path: "/rules", element: <AccessRules />, requiredRole: "ADMIN" },
  ] as RouteConfig[] : [];

  return [...publicRoutes, ...adminRoutes];
};

const renderRoutes = (routes: RouteConfig[]) => {
  return routes.map(({ path, element, requiredRole }) => (
    <Route
      key={path}
      path={path}
      element={
        requiredRole ? 
        <ProtectedRoute element={element} requiredRole={requiredRole} /> : 
        element
      }
    />
  ));
};

export const ProtectedRoutes: React.FC = () => {
  const { isAdmin } = useAuth();
  const routes = getRoutes(isAdmin);

  return (
    <Routes>
      {renderRoutes(routes)}
      <Route path="*" element={<Navigate to="/not-found" replace />} />
    </Routes>
  );
};
